import { useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ExtensionInstructionsModal } from "@components/Modals";

import { routes } from "@pages/routes";

export const ExtensionInstallation = () => {
  const navigate = useNavigate();
  const { clientId } = useTypedParams(routes.portal.clients.client);

  const handleClose = () => {
    navigate("..", { viewTransition: true });
  };

  return (
    <ExtensionInstructionsModal
      isOpen
      onClose={handleClose}
      clientId={clientId}
    />
  );
};
